import React, {Component} from 'react';

import Marienberg19 from "./Bilder/Marienberg19.jpg";
import Landau19 from "./Bilder/Landau19.jpg";
import Karlsruhe11 from "./Bilder/Karlsruhe11.jpg";
import Jeden from "./Bilder/Jeden.jpg";
import HannoverJeden from "./Bilder/HannoverJeden.jpg";
import SteyrJeden from "./Bilder/SteyrJeden.jpg";
import Giessen19 from "./Bilder/Giessen19.jpg";
import MannheimJeden from "./Bilder/MannheimJeden.jpg";
import MunchenMit from "./Bilder/MünchenMit.jpg";
import Dresden19 from "./Bilder/Dresden19.jpg";
import Koblenz from "./Bilder/Koblenz.jpg";
import Gorlitz from "./Bilder/Görlitz.jpg";
import Lorsch from "./Bilder/Lorsch.jpg";
import Chemnitz05 from "./Bilder/Chemnitz05.jpg";
import Niedersachsen26 from "./Bilder/Niedersachsen26.jpg";
import Weggefaehrten from "./Bilder/Weggefährten.jpg";
import Hamburg26 from "./Bilder/Hamburg26.jpg";
import Wien27 from "./Bilder/Wien27.jpg";
import Brussel from "./Bilder/Brüssel.jpg";
import FreiburgAuto from "./Bilder/FreiburgAuto.jpg"
import Solidarisch from "./Bilder/solidarisch.jpg";
import Organise from "./Bilder/organise.jpg";

import "./App.css";

class Geschehen extends Component {


	UNSAFE_componentWillMount(){
		window.scrollTo(0,0);
	}

render() {	
  return (	

	<div className="homeApp" className="homeAktiv">
	<div className="contentHome"   className="Aktiv" >	
		<div className="Kopf">
		<br/>
			<h2>Demos - Organisationen<br/>Flyer und Prospekte<br/><br/>
				</h2>		
			<p  className="Einleit" >                   
    			Auf Telegram gibt es die Gruppe <br/><br/>
				<a  className="videoText" href="https://www.freiheitsboten.de/" target="_blank" >
				Freiheitsboten
			</a>  <br/><br/>
				Beitreten und viele Flyer herunterladen. <br/><br/>
				<strong>Wichtig!</strong> <br/>
				Wenn Ihr auf dem Laufenden bleiben wollt <br/> 
				<strong>Alles Ausser Mainstream</strong> <br/>
				auf Telegram beitreten.    
   			</p>
			<p className="Barrington">
		<h3>Endlich stehen die führenden Wissenschaftler auf</h3>
			   <a className="videoText" rel="noopener" href="https://www.bitchute.com/video/DrFeKvc7LrTU/" target="_blank" >
				Die Great Barrington Erklärung
				</a>
				<br/>kommentiert von Dr. Bonelli
				<br/><br/>
				<a className="videoText" rel="noopener" href="https://gbdeclaration.org" target="_blank" >
				Die Great Barrington Erklärung 
				</a>
				<br/>Original
		</p>			   
		
		
		<div className="Ein">
		<h3>Demos</h3>
			<a className="videoText2" rel="noopener" href="https://www.protestkarte.de" target="_blank" >
				Protestkarte<br/>unvollständig
			</a>

			<a className="videoText2" rel="noopener" href="https://corona-demo.at" target="_blank" >
				Corona-Demos Österreich
			</a>
			<a className="videoText2"  rel="noopener" href="https://t.me/s/Freiheitsfahrer" target="_blank" >
				Freiheitsfahrer
			</a>	
			<a className="videoText2"  rel="noopener" href="https://t.me/AllesAusserMainstream/17042" target="_blank" >
				Montagsdemos Sachsen
			</a>
			<a className="videoText2"  rel="noopener" href="https://t.me/Haintz/17453" target="_blank" >
				Montagsdemos Niedersachsen
			</a>					
			<a className="videoText2"  rel="noopener" href="https://der-schweigemarsch.de" target="_blank" >
				Der Schweigemarsch<br/>Demo-Termine
			</a>
			<br/>
			<h3>Organisationen</h3>
			<a className="videoText" rel="noopener"  rel="noopener" href="https://www.acu2020.org" target="_blank" >
				Untersuchungsausschuss Corona-Ausschuss
			</a>
			<a className="videoText"  rel="noopener" href="https://www.aerztefueraufklaerung.de" target="_blank" >
				Ärzte für Aufklärung
			</a>
			<a className="videoText"  rel="noopener" href="https://aerzte-stehen-auf.de" target="_blank" >
				Ärzte stehen auf!
			</a>			

			<a className="videoText"  rel="noopener" href="https://www.afaev.de"  target="_blank">				
				Anwälte für Aufklärung
			</a>
			<a className="videoText"  rel="noopener" href="https://vereinnpolifa.org"  target="_blank">				
				Polizisten für Aufklärung
			</a>						
			<a className="videoText"  rel="noopener" href="https://www.schlussjetzt.org"  target="_blank">
				"Schlussjetzt" Rechtsanwältin Viviane Fischer
			</a>
			<a className="videoText" rel="noopener"  href="https://www.elternstehenauf.de" target="_blank" >
				"Eltern stehen auf" Bürgerinitiative
			</a>
			<a className="videoText"  rel="noopener" href="https://klagepaten.eu" target="_blank" >
				KlagePaten
			</a>
			<a className="videoText"  rel="noopener" href="https://mutigmacher.org/beratung-dienstleistung-einbringen/" target="_blank" >
				Mutigmacher e.V.
			</a>
			<br/>
			<br/>
			<a className="videoText"  rel="noopener" href="https://deutschsprachige-gemeinschaft-am-balaton.de/forum" target="_blank" >
			 Viele gehen ins Exil<br/>z.B. Ungarn
			</a>
			

		</div>
		</div>
	<div className="Organisationen">
	<h1 className="aktivSein1">Auf Demos gehen!<br/></h1>
	<p>(wenn nicht verboten)</p>	
	<h1 className="aktivSein">Gesicht zeigen!<br/>Sich organisieren!</h1>
	<p className="beispiel">Zum Beispiel</p>
			<h2>Danke!<br/>
			Berlin 01.08.2020<br/>
			Berlin 29.08.2020<br/>
			Leipzig 07.11.2020<br/>				
			Berlin 18.11.2020<br/>		
			Wien 31.01.2021<br/>
			Wien 13.02.2021<br/>
			Wien 06.03.2021<br/>
			Kassel, Wien, Liestal, Welt 20.03.2021<br/>
			Berlin 21.04.2021<br/>
			Berlin 01.08.2021<br/>
			Bern 23.10.2021<br/>
			Wien 20.11.2021<br/>
			11.12.2021 Danke an Wien und all den anderen Demonstrationen.<br/>
			Amsterdam 02.01.2022<br/>
			Brüssel 23.01.2022<br/>
			Danke an alle Spaziergänger	<br/>
			Danke Sachsen	<br/>
					...</h2>
			<br/>




		

			<br/>
			<img src={Solidarisch} className="Informationen2" alt="Kreislauf" />
			<span>zum Beispiel:</span>
			<img src={Jeden} className="Informationen2" alt="Jeden" />
			<img src={HannoverJeden} className="Informationen2" alt="Hannover" />
			<img src={Lorsch} className="Informationen2" alt="Lorsch" />			
			<img src={MunchenMit} className="Informationen2" alt="München" />
			<img src={Koblenz} className="Informationen2" alt="Koblenz" />	
			<img src={MannheimJeden} className="Informationen2" alt="Mannheim" />	
			<img src={SteyrJeden} className="Informationen2" alt="Steyr" />
			<img src={FreiburgAuto} className="Informationen2" alt="Freiburg" />			
			<img src={Gorlitz} className="Informationen2" alt="Görlitz" />													

			<a className="videoText4"  rel="noopener" href="https://www.montagsdemo.info	" target="_blank" >
				Görlitz
			</a>					
			

			<img src={Weggefaehrten} className="Informationen2" alt="Weggefährten" />			
			<br/>
			<br/>			
		</div>

		<img src={Organise} className="Informationen3" alt="Informationen" />
	
	</div>

</div>

  );
};
};

export default Geschehen;
